(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequire7ff4"];
parcelRequire.register("2ZfvF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22cd4f2fb73c9fd3$export$2e2bcd8739ae039; });

var $3xGDe = parcelRequire("3xGDe");
const $22cd4f2fb73c9fd3$var$Marquee = ()=>{
    const els = document.querySelectorAll(".marquee");
    if (els.length) els.forEach((el)=>{
        const marquee = (0, $3xGDe.default)({
            parent: el,
            speed: parseFloat(el?.dataset?.speed ?? 0.5),
            prependWhitespace: false,
            minQuantity: 3
        });
    });
};
var $22cd4f2fb73c9fd3$export$2e2bcd8739ae039 = $22cd4f2fb73c9fd3$var$Marquee;

});
parcelRequire.register("3xGDe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $294585f41e782189$export$2e2bcd8739ae039; });
parcelRequire("6TrZM");
var $ik4eN = parcelRequire("ik4eN");
var $7ebVC = parcelRequire("7ebVC");
var $gH163 = parcelRequire("gH163");
function $294585f41e782189$export$2e2bcd8739ae039(argProp = {}) {
    // default properties
    const defaults = {
        parent: "#node-marquee",
        speed: 1,
        minQuantity: 4,
        autoplay: true,
        pauseOnHover: false,
        useParentStyles: true,
        prependWhitespace: true,
        resize: true
    };
    // extend properties
    const prop = Object.assign(defaults, argProp);
    // states
    const className = "node-marquee";
    // get parent element
    const parent = (0, $ik4eN.selectOne)(prop.parent);
    if (!(parent instanceof HTMLElement)) return false;
    parent.classList.add(className);
    // states
    const viewportSizes = {
        width: window.innerWidth,
        height: window.innerHeight
    };
    let isDestroyed = false;
    let isPlaying = false;
    let progress = 0;
    let animationFrame = false;
    // data
    let defaultHTML = parent.innerHTML;
    let quantity = 0;
    let items = [];
    let itemWidth = 0;
    // events
    let mutations;
    const listeners = [
        (0, $7ebVC.addEventListener)(window, "resize", handleResize),
        (0, $7ebVC.addEventListener)(parent, "mouseenter", handleMouseEnter),
        (0, $7ebVC.addEventListener)(parent, "mouseleave", handleMouseLeave)
    ];
    // create the marquee
    create();
    // set animation frame
    if (prop.autoplay) play();
    /**
     * Create the marquee elemetnt
     */ function create() {
        // reset events
        disconnectMutations();
        // clear the outer element
        quantity = 0;
        items = [];
        parent.innerHTML = "";
        // apply styles to the outer
        if (prop.useParentStyles) {
            parent.style.position = "relative";
            parent.style.width = "100%";
            parent.style.overflow = "hidden";
            parent.style.whiteSpace = "nowrap";
        }
        // create the first item and get its sizes
        // to calculate the further quantity of inner elements
        const firstItem = createItem();
        itemWidth = firstItem.clientWidth;
        if (itemWidth <= 0) itemWidth = window.innerWidth;
        if (itemWidth < parent.clientWidth) quantity = Math.ceil((parent.clientWidth + itemWidth) / itemWidth);
        if (quantity < prop.minQuantity) quantity = prop.minQuantity;
        // now when we know the total quantity,
        // we can create the rest of the items
        for(let index = 1; index < quantity; index += 1)createItem(true);
        // render for the first time
        renderItems();
        // enable mutation observer
        observeMutations();
        // and to be sure, update sizes once more
        setTimeout(()=>{
            updateSizes();
        }, 500);
    }
    /**
     * Create a single element inside the marquee
     */ function createItem(isAbsolute = false) {
        const element = (0, $gH163.createElement)("div", {
            class: `${className}__el`,
            html: `${prop.prependWhitespace ? "&nbsp;" : ""}${defaultHTML}`
        });
        // apply styles
        if (isAbsolute) {
            element.style.position = "absolute";
            element.style.top = "0";
            element.style.left = "0";
        }
        element.style.display = "inline-block";
        // append the element
        parent.appendChild(element);
        items.push(element);
        return element;
    }
    /**
     * Event on window resize
     */ function handleResize() {
        if (prop.resize === false) return;
        const prevViewportWidth = viewportSizes.width;
        const prevViewportHeight = viewportSizes.height;
        const newViewportWidth = window.innerWidth;
        const newViewportHeight = window.innerHeight;
        viewportSizes.width = newViewportWidth;
        viewportSizes.height = newViewportHeight;
        if (typeof prop.resize === "string") {
            if (prop.resize === "w" && prevViewportWidth !== newViewportWidth || prop.resize === "h" && prevViewportHeight !== newViewportHeight) {
                create();
                return;
            }
            return;
        }
        create();
    }
    /**
     * Event on hover - ON
     */ function handleMouseEnter() {
        if (prop.pauseOnHover) pause();
    }
    /**
     * Event on hover - OFF
     */ function handleMouseLeave() {
        if (prop.pauseOnHover) play();
    }
    /**
     * Observe DOM content changes
     * If a change happend inside the parent element,
     * we recreate the marquee element
     */ function observeMutations() {
        if (mutations) return;
        const config = {
            childList: true
        };
        const callback = (mutationsList)=>{
            for (const mutation of mutationsList)if (mutation.type === "childList") {
                defaultHTML = parent.innerHTML;
                create();
            }
        };
        mutations = new MutationObserver(callback);
        mutations.observe(parent, config);
    }
    /**
     * Destroy mutation observer
     */ function disconnectMutations() {
        if (mutations) {
            mutations.disconnect();
            mutations = undefined;
        }
    }
    /**
     * Update sizes
     */ function updateSizes() {
        if (isDestroyed) return;
        const width = [];
        for(let index = 0; index < quantity; index += 1)width.push(items[index].clientWidth);
        itemWidth = Math.max(...width);
    }
    /**
     * Render the marquee
     */ function render() {
        if (isPlaying) animationFrame = window.requestAnimationFrame(render);
        renderItems();
    }
    /**
     * Render inner elements
     */ function renderItems(speed = prop.speed) {
        progress -= speed;
        // get total width
        const totalWidth = itemWidth * (quantity - 1);
        // render elements
        for(let index = 0; index < quantity; index += 1){
            const el = items[index];
            // calulate transforms
            const x = wrap(-itemWidth, totalWidth, progress + itemWidth * index);
            // apply transforms
            el.style.transform = `matrix3d(1,0,0.00,0,0.00,1,0.00,0,0,0,1,0, ${x}, 0, 0,1)`;
        }
    }
    function wrap(min, max, value) {
        const range = max - min;
        return conditionalReturn(value, (val)=>(range + (val - min) % range) % range + min);
    }
    function conditionalReturn(value, func) {
        return value || value === 0 ? func(value) : func;
    }
    /**
     * Play the marquee
     */ function play() {
        if (!animationFrame) {
            isPlaying = true;
            animationFrame = window.requestAnimationFrame(render);
        }
    }
    /**
     * Pause the marquee
     */ function pause() {
        isPlaying = false;
        if (animationFrame) {
            window.cancelAnimationFrame(animationFrame);
            animationFrame = false;
        }
    }
    /**
     * Destroy the marquee element
     */ function destroy() {
        isDestroyed = true;
        pause();
        disconnectMutations();
        listeners.forEach((listener)=>{
            listener.remove();
        });
        parent.innerHTML = defaultHTML;
    }
    return {
        play: play,
        pause: pause,
        isPlaying: ()=>isPlaying,
        render: renderItems,
        recreate: create,
        updateSizes: updateSizes,
        destroy: destroy
    };
}

});
parcelRequire.register("6TrZM", function(module, exports) {

$parcel$export(module.exports, "selectOne", function () { return (parcelRequire("ik4eN")).selectOne; });
$parcel$export(module.exports, "createElement", function () { return (parcelRequire("gH163")).createElement; });
$parcel$export(module.exports, "addEventListener", function () { return (parcelRequire("7ebVC")).addEventListener; });

var $kVWd9 = parcelRequire("kVWd9");

var $hRNgD = parcelRequire("hRNgD");

var $4aPGM = parcelRequire("4aPGM");

var $4Fpuv = parcelRequire("4Fpuv");

var $68hWN = parcelRequire("68hWN");

var $ik4eN = parcelRequire("ik4eN");

var $jsR57 = parcelRequire("jsR57");

var $8HTBm = parcelRequire("8HTBm");

var $gH163 = parcelRequire("gH163");

var $g5Qhz = parcelRequire("g5Qhz");

var $7ebVC = parcelRequire("7ebVC");

var $7mxIv = parcelRequire("7mxIv");

var $1gwT2 = parcelRequire("1gwT2");

var $bl7Jl = parcelRequire("bl7Jl");

});
parcelRequire.register("kVWd9", function(module, exports) {
/**
 * Insert an element after another one.
 */ function $f3d6490ebb7bcc44$export$c4f94c8b3850a5a9(/**
 * The element to be inserted
 */ element, /**
 * The reference element after which the first element will be appended.
 */ referenceElement) {
    const parent = referenceElement.parentNode;
    const next = referenceElement.nextSibling;
    if (next) parent.insertBefore(element, next);
    else parent.appendChild(element);
}

});

parcelRequire.register("hRNgD", function(module, exports) {

$parcel$export(module.exports, "childOf", function () { return $d01d9a58216709bf$export$840a2358f4270994; });
/**
 * Check if an element is a child of another element.
 */ function $d01d9a58216709bf$export$840a2358f4270994(/**
 * The element to be checked
 */ element, /**
 * Parent element
 */ parent) {
    return $d01d9a58216709bf$var$childOfCheck(element, parent);
}
/**
 * @ignore
 */ function $d01d9a58216709bf$var$childOfCheck(el, parent) {
    if (el === parent) return true;
    if (el !== null) return $d01d9a58216709bf$var$childOfCheck(el.parentNode, parent);
    return false;
}

});

parcelRequire.register("4aPGM", function(module, exports) {
/**
 * Remove children of an element
 */ function $30a030f52a6d8756$export$1e1c9bf5a4ffe0d1(parent) {
    while(parent.firstChild)parent.removeChild(parent.firstChild);
}

});

parcelRequire.register("4Fpuv", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $365ec3c3fe2833e2$export$45a5e7f76e0caa8d; });
/**
 * Check if the variable is an HTML Element.
 */ function $365ec3c3fe2833e2$export$45a5e7f76e0caa8d(el) {
    return el instanceof HTMLElement || el instanceof Element;
}

});

parcelRequire.register("68hWN", function(module, exports) {

$parcel$export(module.exports, "isWindow", function () { return $47716965348798c9$export$5a096129d439f843; });
/**
 * Check if the variable is the Window instance.
 */ function $47716965348798c9$export$5a096129d439f843(el) {
    return el instanceof Window;
}

});

parcelRequire.register("ik4eN", function(module, exports) {

$parcel$export(module.exports, "selectOne", function () { return $d56d61bca522aa80$export$9633ae49ba77655e; });

var $4Fpuv = parcelRequire("4Fpuv");

var $68hWN = parcelRequire("68hWN");
function $d56d61bca522aa80$export$9633ae49ba77655e(/**
 * Query selector
 */ selector, /**
 * A parent for the needed element
 */ parent) {
    if ((0, $68hWN.isWindow)(selector)) return selector;
    if ((0, $4Fpuv.isElement)(selector)) return selector;
    // if string
    if (typeof parent !== "undefined") {
        const parenEl = $d56d61bca522aa80$export$9633ae49ba77655e(parent);
        if (parenEl) return parenEl.querySelector(selector);
    }
    return document.querySelector(selector);
}

});

parcelRequire.register("jsR57", function(module, exports) {

var $4Fpuv = parcelRequire("4Fpuv");

var $ik4eN = parcelRequire("ik4eN");
function $e2b9cebe5bf3f284$export$90aca4adda6ff0f5(/**
 * Query selector
 */ selector, /**
 * A parent for the needed elements
 */ parent) {
    if (selector instanceof NodeList) return selector;
    if ((0, $4Fpuv.isElement)(selector)) return [
        selector
    ];
    if (Array.isArray(selector)) return selector;
    // if string
    if (typeof parent !== "undefined") {
        const parenEl = (0, $ik4eN.selectOne)(parent);
        if (parenEl) return parenEl.querySelectorAll(selector);
    }
    return document.querySelectorAll(selector);
}

});

parcelRequire.register("8HTBm", function(module, exports) {

var $hRNgD = parcelRequire("hRNgD");
function $656d782f16ebf095$export$5e4dbe6e00d7fc88(/**
 * The element to be checked.
 */ el) {
    return (0, $hRNgD.childOf)(el, document.documentElement);
}

});

parcelRequire.register("gH163", function(module, exports) {

$parcel$export(module.exports, "createElement", function () { return $c2718340a20d6ba7$export$c8a8987d4410bf2d; });

var $g5Qhz = parcelRequire("g5Qhz");
function $c2718340a20d6ba7$export$c8a8987d4410bf2d(/**
 * TagName
 */ selector, /**
 * Element properties
 */ prop = {}) {
    // create an element
    const el = document.createElement(selector);
    // add classes
    if (prop.class) (0, $g5Qhz.addClass)(el, prop.class);
    // add id
    if (prop.id) el.setAttribute("id", prop.id);
    // add attributes
    if (prop.attr) for(let i = 0, l = prop.attr.length; i < l; i++){
        const attrInfo = prop.attr[i];
        el.setAttribute(attrInfo[0], attrInfo[1]);
    }
    // append to parent
    if (prop.parent) prop.parent.appendChild(el);
    // add html
    if (prop.html) el.innerHTML = prop.html;
    // add children
    if (prop.children) for(let i = 0, l = prop.children.length; i < l; i++)el.appendChild(prop.children[i]);
    // return the element
    return el;
}

});
parcelRequire.register("g5Qhz", function(module, exports) {

$parcel$export(module.exports, "addClass", function () { return $bb75ab30921a31b1$export$d2cf6cd1dc7067d3; });
/**
 * Add a class name or names to an element or a collection of elements
 */ function $bb75ab30921a31b1$export$d2cf6cd1dc7067d3(/**
 * The target element (elements)
 */ el, /**
 * ClassName or names split by whitespace
 */ classNames) {
    if (el instanceof Element) $bb75ab30921a31b1$var$setElClass(el, classNames, true);
    else for(let i = 0; i < el.length; i++)$bb75ab30921a31b1$var$setElClass(el[i], classNames, true);
}
function $bb75ab30921a31b1$export$c2255604a80b4506(/**
 * The target element (elements)
 */ el, /**
 * ClassName or names split by whitespace
 */ classNames) {
    if (el instanceof Element) $bb75ab30921a31b1$var$setElClass(el, classNames, false);
    else for(let i = 0; i < el.length; i++)$bb75ab30921a31b1$var$setElClass(el[i], classNames, false);
}
function $bb75ab30921a31b1$export$4a80062ca50b57c7(/**
 * The target element (elements)
 */ el, /**
 * ClassName or names split by whitespace
 */ classNames) {
    if (el instanceof Element) $bb75ab30921a31b1$var$setElClass(el, classNames);
    else for(let i = 0; i < el.length; i++)$bb75ab30921a31b1$var$setElClass(el[i], classNames);
}
///
function $bb75ab30921a31b1$var$setElClass(/**
 * The element
 */ e, /**
 * Class names
 */ classNames, /**
 * Undefined - toggle, true - add, false - remove
 */ action) {
    const names = classNames.split(" ");
    for(let i = 0; i < names.length; i++){
        if (typeof action === "undefined") e.classList.toggle(names[i]);
        else if (action) e.classList.add(names[i]);
        else e.classList.remove(names[i]);
    }
}

});


parcelRequire.register("7ebVC", function(module, exports) {

$parcel$export(module.exports, "addEventListener", function () { return $543317e86e84ad35$export$3f65cefe8380dbea; });
// event listeners
const $543317e86e84ad35$var$listeners = [];
function $543317e86e84ad35$export$3f65cefe8380dbea(el, target, callback, options) {
    // check if options exist
    if (typeof options !== "undefined") {
        const listenerOptions = {
            passive: false,
            once: false
        };
        // check if once
        if (options.once) listenerOptions.once = true;
        // check if passive
        if (options.passive) listenerOptions.passive = true;
        // add an event listener
        el.addEventListener(target, callback, listenerOptions);
    } else // add an event listener
    el.addEventListener(target, callback);
    // generate an id for the listener
    const id = `${Math.random()}-${+new Date()}`;
    // add the listener to the stack
    $543317e86e84ad35$var$listeners.push({
        id: id,
        el: el,
        target: target,
        callback: callback
    });
    // return data
    return {
        id: id,
        remove: $543317e86e84ad35$export$8ff9f68337b520c0.bind(this, id)
    };
}
function $543317e86e84ad35$export$8ff9f68337b520c0(/**
 * Id of the listener
 */ id) {
    // form a new array of listeners
    const newListeners = [];
    // go through all callbacks and search for the required one
    for(let i = 0, l = $543317e86e84ad35$var$listeners.length; i < l; i++){
        const data = $543317e86e84ad35$var$listeners[i];
        // remove the callback
        if (data.id === id) data.el.removeEventListener(data.target, data.callback);
        else {
            // add the listener to the new array
            newListeners.push(data);
            continue;
        }
    }
}

});

parcelRequire.register("7mxIv", function(module, exports) {
/**
 * Get the nearest parent element by instance.
 */ function $55c4bdf45153fbe0$export$2e2bcd8739ae039(/**
 * The reference element (child)
 */ child, /**
 * The instance
 */ instance, /**
 * Maximum nesting level
 */ maxLevel = Infinity, /**
 * Current level
 */ currentLevel = 0) {
    // check nesting level
    if (currentLevel >= maxLevel) return false;
    // and iterate
    currentLevel++;
    // if overlap, return the parent
    if (child.parentElement instanceof Element) {
        if (child.parentElement instanceof $55c4bdf45153fbe0$var$fixInstance(instance)) return child.parentElement;
        return $55c4bdf45153fbe0$export$2e2bcd8739ae039(child.parentElement, instance, maxLevel, currentLevel);
    }
    return false;
}
/**
 * @ignore
 */ function $55c4bdf45153fbe0$var$fixInstance(instance) {
    return instance;
}

});

parcelRequire.register("1gwT2", function(module, exports) {
/**
 * Get the nearest parent element by tagName.
 */ function $0ec0cbb3fd293448$export$2e2bcd8739ae039(/**
 * The reference element (child)
 */ child, /**
 * Tagname of the parent
 */ tagName, /**
 * Maximum nesting level
 */ maxLevel = Infinity, /**
 * Current level
 */ currentLevel = 0) {
    // check nesting level
    if (currentLevel >= maxLevel) return false;
    // and iterate
    currentLevel++;
    // if overlap, return the parent
    if (child.parentElement instanceof Element) {
        if (child.parentElement.tagName.toLowerCase() === tagName.toLowerCase()) return child.parentElement;
        return $0ec0cbb3fd293448$export$2e2bcd8739ae039(child.parentElement, tagName, maxLevel, currentLevel);
    }
    return false;
}

});

parcelRequire.register("bl7Jl", function(module, exports) {
/**
 * Get the nearest parent element by tagName.
 */ function $8417a6f1dff83cf4$export$2e2bcd8739ae039(/**
 * The reference element (child)
 */ child, /**
 * Classname of the parent
 */ className, /**
 * Maximum nesting level
 */ maxLevel = Infinity, /**
 * Current level
 */ currentLevel = 0) {
    // check nesting level
    if (currentLevel >= maxLevel) return false;
    // and iterate
    currentLevel++;
    // if overlap, return the parent
    if (child.parentElement instanceof Element) {
        if (child.parentElement.classList.contains(className)) return child.parentElement;
        return $8417a6f1dff83cf4$export$2e2bcd8739ae039(child.parentElement, className, maxLevel, currentLevel);
    }
    return false;
}

});




})();
//# sourceMappingURL=marquee.8233e126.js.map
